import { useMutation } from "@tanstack/react-query";
import apiV2 from "api-v2";
import type { RecoveryCodesResource } from "../types/Mfa.type";
import { useInvalidateMfaStatus } from "./useMfaStatus";

export interface RegenerateRecoveryCodesPayload {
	password: string;
}

const regenerateRecoveryCodes = async (
	payload: RegenerateRecoveryCodesPayload
): Promise<RecoveryCodesResource> => {
	const response = await apiV2.post("/mfa/recovery-codes/regenerate", payload);
	return (response.data as { data?: RecoveryCodesResource })?.data ?? response.data;
};

export const useRegenerateRecoveryCodes = () => {
	const invalidateMfaStatus = useInvalidateMfaStatus();

	return useMutation<RecoveryCodesResource, Error, RegenerateRecoveryCodesPayload>({
		mutationFn: regenerateRecoveryCodes,
		onSuccess: () => {
			invalidateMfaStatus();
		},
	});
};
